/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerRightUpIcon16Regular = forwardRef('ArrowDCornerRightUpIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M14.03 6.22a.75.75 0 0 1-1.06 1.06L9.75 4.06V12A2.75 2.75 0 0 1 7 14.75H.75a.75.75 0 0 1 0-1.5H7c.69 0 1.25-.56 1.25-1.25V4.06L5.03 7.28a.75.75 0 1 1-1.06-1.06L7.62 2.568a1.95 1.95 0 0 1 2.758 0L14.03 6.22Z" })));
});
